import swal from 'sweetalert';

(() => {
  angular
    .module('app')
    .controller('clinic.views.healthScreeningCheckIn', [
      '$state',
      '$filter',
      '$stateParams',
      'abp.services.app.commonLookup',
      'lookupModal',
      'appSession',
      '$uibModal',
      'abp.services.app.clinicEmployee',
      controller,
    ]);

  function controller(
    $state,
    $filter,
    $stateParams,
    commonLookupSvc,
    lookupModal,
    appSession,
    $uibModal,
    clinicEmployeeSvc
  ) {
    const vm = this;
    vm.loading = 0;
    vm.isReadOnly = true;
    vm.filterText = $stateParams.filterText || '';
    vm.searched = '';
    vm.hasClinicLocation = appSession.user.clinicLocationId;
    vm.patientList = null;
    vm.patientPendingSubmissionsList = null;
    let cycle = '';
    vm.employeeFoundMessage = '';

    // As this page will only be used by health screening,
    // thus the default service type will be 9.

    vm.serviceType = 9;

    vm.hasSearchEmployeesForPanelEnhancement = abp.setting.getBoolean(
      'Hms.Feature.SearchEmployeesForPanelEnhancement'
    );

    vm.hasPanelPatientSearchForAdvancedSecurityEnhancement = abp.setting.getBoolean(
      'Hms.Feature.PanelPatientSearchForAdvancedSecurityEnhancement'
    );

    // Init section.

    function init() {
      getTenantCurrencyCode();
      commonLookupSvc
        .getDefaultClinicLocation()
        .success((data) => {
          setLocation(data);
          vm.patientNotFoundMessage = App.localize(
            'PatientNotFoundMessage3',
            data.accountOwnerContactNumber
          );
        })
        .finally(() => {
          if (!vm.clinic.clinicLocationId) {
            vm.changeLocation();
          } else {
            vm.getEmployees();
          }
        });

      getTimeZoneId();
    }

    function setLocation(location) {
      vm.clinic = {};

      vm.clinic.clinicLocationId = parseInt(location.value, 10) || null;
      vm.clinic.name = location.name;
      vm.clinic.address = location.address;
      vm.clinic.contactNumber = location.contactNumber;
    }

    vm.getEmployees = function getEmployees() {
      const { filterText } = vm;
      $state.transitionTo(
        $state.current,
        {
          filterText,
        },
        {
          notify: false,
        }
      );

      vm.loading += 1;
      if (vm.hasSearchEmployeesForPanelEnhancement) {
        clinicEmployeeSvc
          .getEmployeesForHealthScreening({
            filter: filterText,
            clinicLocationId: vm.clinic.clinicLocationId,
            serviceType: vm.serviceType,
          })
          .success((data) => {
            vm.patientList = [];
            vm.patientPendingSubmissionsList = [];

            processGetEmployeesOutput(data.items);
            vm.searched = vm.filterText;
          })
          .finally(() => {
            vm.loading -= 1;
          });
      } else {
        clinicEmployeeSvc
          .getEmployeesByNationalId({
            filter: filterText,
            clinicLocationId: vm.clinic.clinicLocationId,
            serviceType: vm.serviceType,
          })
          .success((data) => {
            vm.patientList = [];
            vm.patientPendingSubmissionsList = [];

            processGetEmployeesOutput(data.items);
            vm.searched = vm.filterText;
          })
          .finally(() => {
            vm.loading -= 1;
          });
      }
    };

    function processGetEmployeesOutput(data) {
      const allEmployees = data || [];

      const pendingSubmissions = [];
      const newEmployees = [];

      _.each(allEmployees, (employee) => {
        if (
          employee.checkedInTime &&
          employee.pendingClaimSubmissionGLs &&
          employee.pendingClaimSubmissionGLs.length > 0
        ) {
          const lastPendingClaimSubmissionGL =
            employee.pendingClaimSubmissionGLs[employee.pendingClaimSubmissionGLs.length - 1];
          employee.listingTime =
            lastPendingClaimSubmissionGL.approvalTime < employee.checkedInTime
              ? lastPendingClaimSubmissionGL.approvalTime
              : employee.checkedInTime;

          pendingSubmissions.push(employee);
          const letter = _.find(employee.guaranteeLetters, ['letterNumber', vm.filterText]);
          if (_.camelCase(vm.filterText).toUpperCase() === employee.nationalId || letter) {
            newEmployees.push(employee);
          }
        } else {
          newEmployees.push(employee);
        }
      });

      _.orderBy(pendingSubmissions, ['listingTime'], ['desc']);

      vm.patientList = newEmployees;
      vm.patientPendingSubmissionsList = pendingSubmissions;

      vm.employeeFoundMessage = App.localize('EmployeeFoundMessageVersion2', data.length);
    }

    vm.changeLocation = function changeLocation() {
      lookupModal.open({
        title: App.localize('SelectPanelLocation'),
        serviceMethod: commonLookupSvc.findClinicLocations,
        callback(location) {
          setLocation(location);
          vm.patientNotFoundMessage = App.localize(
            'PatientNotFoundMessage3',
            location.accountOwnerContactNumber
          );

          vm.getEmployees();
        },
      });
    };

    // Select GL from list for check in.
    vm.showCheckInModal = function showCheckInModal(employee) {
      vm.employee = employee;
      employee.guaranteeLetters = _.filter(employee.guaranteeLetters, (k) => k.status !== 3);
      $uibModal
        .open({
          templateUrl: require('./applyGuaranteeLetterModal.html'),
          controller: 'clinic.views.healthScreeningApplyGuaranteeLetterModal as vm',
          backdrop: 'static',
          resolve: {
            employee() {
              return employee;
            },
            clinic() {
              return vm.clinic;
            },
          },
        })
        .result.then((data) => {
          // Check-in using this GL number.
          if (data && data.letterNumber) {
            vm.letterNumber = data.letterNumber;
            checkIn(employee);
          }
        });
    };

    function checkIn(employee) {
      vm.loading += 1;
      clinicEmployeeSvc
        .checkIn({
          employeeId: employee.id,
          clinicLocationId: vm.clinic.clinicLocationId,
          guaranteeLetterNumber: vm.letterNumber,
        })
        .success((data) => {
          getCheckInDetail(data);
          vm.getEmployees();
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    vm.cancel = function cancel(employee, uniqueId) {
      $uibModal
        .open({
          templateUrl: require('./checkOutModal.html'),
          controller: 'clinic.views.healthScreeningCheckOutModal as vm',
          backdrop: 'static',
        })
        .result.then((reason) => {
          if (reason) {
            employee.cancellationRemarks = reason;
            checkOut(employee, uniqueId);
          }
        });
    };

    function checkOut(employee, uniqueId) {
      vm.loading += 1;
      clinicEmployeeSvc
        .checkOut({
          employeeId: employee.id,
          clinicLocationId: vm.clinic.clinicLocationId,
          cancellationRemarks: employee.cancellationRemarks,
          guaranteeLetterUniqueId: uniqueId,
        })
        .success(() => {
          vm.getEmployees();
          abp.notify.info(App.localize('PatientXCheckedOut', employee.name));
          swal.close();
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getCheckInDetail(id) {
      vm.loading += 1;
      clinicEmployeeSvc
        .getCheckInDetail({
          id,
        })
        .success((data) => {
          vm.employee.checkedInTime = data.checkedInTime;
          vm.employee.checkOutTime = data.checkOutTime;

          if (data.allowance > 0) {
            vm.employee.allowance = data.allowance;
            vm.employee.allowanceDisplay = getAllowanceDisplay(
              vm.employee.allowance,
              vm.employee.allowancePeriod
            );
          }

          promptCheckInSuccessMessage();
          abp.notify.info(App.localize('PatientXCheckedIn', vm.employee.name));
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function promptCheckInSuccessMessage() {
      function getMessage() {
        const titles = [App.localize('CheckedIn')];
        const msgs = [];
        if (!vm.employee.allowance) {
          if (!vm.employee.canAccess) {
            msgs.push(App.localize('PatientUnableToMakeCashlessClaim'));
            msgs.push(App.localize('CheckInSuccessCollectCashNarrative'));
            return {
              titles,
              msgs,
            };
          }
          msgs.push(App.localize('PatientMustPayCash'));
        } else {
          if (vm.employee.allowance <= 30) {
            msgs.push(App.localize('PatientLowLimitAndPayExcess'));
          }

          if (vm.employee.coPay) {
            if (vm.employee.coPay.isPercentage) {
              vm.employee.coPay.title = App.localize('CopayX', `${vm.employee.coPay.value}%`);
              vm.employee.coPay.text = App.localize(
                'PatientHasCopayPercentage',
                `${vm.employee.coPay.value}%`
              );
            } else {

              // this needs to be updated currency code
              const valueText = $filter('currencyFormat')(vm.employee.coPay.value, vm.currencyCode);
              vm.employee.coPay.title = App.localize('CopayX', valueText);
              vm.employee.coPay.text = App.localize('PatientHasCopayFixedAmount', valueText);
            }

            titles.push(vm.employee.coPay.title);
            msgs.push(vm.employee.coPay.text);
          }
        }

        if (vm.employee.isPreEmployee)
          msgs.push(App.localize('PreEmployeeCheckInSuccessNarrative'));
        else {
          msgs.push(App.localize('HealthScreeningCheckInSuccessNarrative'));
          msgs.push(App.localize('HealthScreeningCheckInSuccessNarrative2'));
        }
        return {
          titles,
          msgs,
        };
      }

      const message = getMessage();
      const title = _.join(message.titles || [], '<br />');
      const text = `<span><b>${App.localize('GLApproved')} </b></span>${App.localize(
        'CheckInSuccessMessage'
      )}<br /><br /><b class="font-uppercase">${_.toUpper(
        App.localize('Important')
      )}:</b><br />${_.join(message.msgs || [], ' ')}`;

      window.onbeforeunload = function onbeforeunload() {
        return title;
      };
      swal(
        {
          title,
          type: 'success',
          text,
          showConfirmButton: true,
          confirmButtonText: App.localize('Understood'),
          html: true,
        },
        () => {
          window.onbeforeunload = null; // unregister
        }
      );
      App.swal.disableButtons(5);
    }

    function getAllowanceDisplay(allowance, allowancePeriod) {
      const allowanceText = $filter('currencyFormat')(
        Math.min(allowance, vm.defaultMaxAllowance),
        vm.currencyCode
      );

      if (!allowancePeriod) return allowanceText;

      switch (allowancePeriod.cycle) {
        case 0:
          cycle = App.localize('EveryXYears', allowancePeriod.interval);
          break;
        case 1:
          cycle = App.localize('Yearly');
          break;
        case 2:
          cycle = App.localize('Monthly');
          break;
        case 3:
          cycle = App.localize('Daily');
          break;
        case 4:
          cycle = App.localize('PerVisit');
          break;
        case 5:
          cycle = App.localize('Every6Months');
          break;
        case 6:
          cycle = App.localize('Every4Months');
          break;
        case 7:
          cycle = App.localize('Every3Months');
          break;
        case 8:
          cycle = App.localize('Every2Months');
          break;
        default:
          break;
      }
      return `${allowanceText} ${cycle.toLowerCase()}`;
    }

    function getTimeZoneId() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantIanaTimeZoneId({})
        .success((data) => {
          vm.timeZoneId = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getTenantCurrencyCode() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantCurrencyCode()
        .then((response) => {
          const { data } = response;
          vm.currencyCode = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    init();
  }
})();
